/**
 * Update Listing Count
 * Updates the total count of properties based on the data-count attribute
 */

const updateListingCount = () => {
    const listingContainer = document.querySelector('[data-count]');
    const countDisplay = document.querySelector('.js-listing-total-count');

    if (listingContainer && countDisplay) {
        const count = listingContainer.getAttribute('data-count');
        countDisplay.textContent = count;
    }
};

export default updateListingCount;
